// extracted by mini-css-extract-plugin
export default {"colStyle":"counterparty_colStyle__XG5VO","colHead":"counterparty_colHead__cGEZt"};